import { MessageCircleMore } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const MessageCircleIcon = createLucideIcon(MessageCircleMore);
